import { LoadingLayout } from "common/components/layouts/LoadingLayout";
import { Loading } from "common/components/Loading";
import { SimpleErrorMessage } from "common/components/SimpleErrorMessage";
import { config } from "common/config";
import { urls } from "common/urls";
import React from "react";
import { Route, Routes } from "react-router-dom";

// For helping us during development.
export const DevRoutes: React.FC = () => {
  if (!config.showDevUtils) {
    return null;
  }

  return (
    <>
      <Routes>
        <Route
          path={urls.devLoadingExample}
          element={
            <LoadingLayout>
              <Loading />
            </LoadingLayout>
          }
        />
        <Route
          path={urls.devErrorExample}
          element={
            <LoadingLayout>
              <SimpleErrorMessage>
                Example of an error message
              </SimpleErrorMessage>
            </LoadingLayout>
          }
        />
      </Routes>
    </>
  );
};
